// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-body {
  position: fixed !important;
  left: 8%;
  top: 200px;
  z-index: 999;
}
.sidebar-body a {
  font-family: "Chakra Petch";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  color: #ffffff !important;
  cursor: pointer;
  position: relative;
  padding-left: 8px;
  text-transform: uppercase;
}

.sidebar-body .active-link {
  text-decoration: none;
  padding: 4px;
  background: linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 100%,
    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 0 0,
    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 100% 0,
    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 0 100%,
    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 100% 100% #4a19ed;
  background-repeat: no-repeat;
  background-size: 12px 12px;
}

.sidebar-body .nav-body::before {
  border: 0.5px solid #4a19ed;
  content: "";
  display: inline-block;
  left: -42px;
  height: calc(100% - 2.45rem);
  position: absolute;
  top: 50.5%;
  transform: translateY(-50%);
  vertical-align: middle;
}

.sidebar-body a::before {
  background: #4a19ed;
  content: "";
  display: inline-block;
  height: 0.5px;
  left: -0.3125rem;
  position: absolute;
  top: 50%;
  transform: translate(-100%);
  width: 36px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,QAAQ;EACR,UAAU;EACV,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ;;;;;;;6EAO2E;EAC3E,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb","sourcesContent":[".sidebar-body {\n  position: fixed !important;\n  left: 8%;\n  top: 200px;\n  z-index: 999;\n}\n.sidebar-body a {\n  font-family: \"Chakra Petch\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 40px;\n  color: #ffffff !important;\n  cursor: pointer;\n  position: relative;\n  padding-left: 8px;\n  text-transform: uppercase;\n}\n\n.sidebar-body .active-link {\n  text-decoration: none;\n  padding: 4px;\n  background: linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to right, #ffffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to left, #ffffff 0.5px, transparent 2px) 100% 100%,\n    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 0 0,\n    linear-gradient(to bottom, #ffffff 0.5px, transparent 2px) 100% 0,\n    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 0 100%,\n    linear-gradient(to top, #ffffff 0.5px, transparent 2px) 100% 100% #4a19ed;\n  background-repeat: no-repeat;\n  background-size: 12px 12px;\n}\n\n.sidebar-body .nav-body::before {\n  border: 0.5px solid #4a19ed;\n  content: \"\";\n  display: inline-block;\n  left: -42px;\n  height: calc(100% - 2.45rem);\n  position: absolute;\n  top: 50.5%;\n  transform: translateY(-50%);\n  vertical-align: middle;\n}\n\n.sidebar-body a::before {\n  background: #4a19ed;\n  content: \"\";\n  display: inline-block;\n  height: 0.5px;\n  left: -0.3125rem;\n  position: absolute;\n  top: 50%;\n  transform: translate(-100%);\n  width: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
